import React, { useEffect, useState } from "react";
import { AnimatedTestimonials } from "../ui/AnimatedTestimonials";
import { getPublicContacts, PLACEHOLDER_AVATAR } from "../../services/contactsService";
import s from "./Contacts.module.css";

const Contacts = () => {
  const [contacts, setContacts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    getPublicContacts()
      .then((data) => {
        if (!cancelled) setContacts(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (!cancelled) {
          setError("Не удалось загрузить контакты. Попробуйте позже.");
        }
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const testimonials = contacts.map((contact) => ({
    id: contact.id,
    src: contact.avatarUrl || PLACEHOLDER_AVATAR,
    name: contact.name,
    designation: contact.designation,
    email: contact.email,
    phoneNumber: contact.phoneNumber,
    socialMedia: contact.socialMedia,
  }));

  return (
    <div className={s.container}>
      <h1 className={s.title}>Связаться с нами</h1>
      <p className={s.subtitle}>Руководство организации</p>

      {isLoading ? (
        <div className={s.empty}>Загрузка…</div>
      ) : error ? (
        <div className={s.empty}>{error}</div>
      ) : testimonials.length > 0 ? (
        <AnimatedTestimonials testimonials={testimonials} autoplay={false} />
      ) : null}
    </div>
  );
};

export default Contacts;
